<template>
  <BaseList listSubtitulo="Lista das etapas da construção" :data="dados.results" :columns="columns"
            :globalFilterFields="columns" :totalRecords="dados.count" @update:pagination="loadDataLazy">
    <template v-slot:incluirCadastro>
      <button v-if="isStaff" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>
    </template>

    <template #actions="{ data }">
      <div class="dropdown text-center">
        <button
            class="btn btn-info btn-sm dropdown-toggle font-bold"
            type="button"
            data-toggle="dropdown" data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
        >
          OPÇÕES
        </button>
        <ul class="dropdown-menu p-2 border-0 shadow-sm rounded-3">
          <li>
            <button class="btn btn-outline-primary font-bold mb-1 w-100 rounded"
                    @click="abrirModal('cadastroConstrucaoMaterial', data.id, data.key, `${data.construcao_exibicao} - ${data.etapa_exibicao}`)">
              <i class="fa fa-plus"></i> MATERIAIS DA ETAPA
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('editar', data.id, data.key)">
              <i class="fa fa-edit"></i> Atualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-danger font-bold mb-1 w-100 rounded"
                    @click="deletarItem(data.key, data.id, `${data.construcao_exibicao} - ${data.etapa_exibicao}`)">
              <i class="fa fa-trash"></i> Excluir
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseList>
  <CadastrarConstrucaoEtapas
      v-if="modalAtivo === 'cadastro'"
      :idModal="'cadastarConstrucaoEtapa'"
      :construcaoId="Number(construcaoId)"
      :construcaoDescricao="construcaoDescricao"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
  <EditarConstrucaoEtapa
      v-if="modalAtivo === 'editar'"
      :idModal="'editarConstrucaoEtapa'"
      :construcaoDescricao="construcaoDescricao"
      :construcaoEtapaKey="construcaoEtapaKeySelect"
      @fechar="fecharModal"
      @atualizarDados="atualizaDados"
  />
  <CadastrarConstrucaoMaterial
      v-if="modalAtivo === 'cadastroConstrucaoMaterial'"
      :idModal="'cadastrarConstrucaoMaterial'"
      :construcaoEtapa="construcaoEtapaDescricao"
      :construcaoEtapaId="construcaoEtapaSelect"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastrarConstrucaoEtapas from "./CadastrarConstrucaoEtapas.vue";
import EditarConstrucaoEtapa from "./EditarConstrucaoEtapa.vue";
import CadastrarConstrucaoMaterial from "./materiais_construcao/CadastrarConstrucaoMaterial.vue";
import {apiRequest, alertDelete} from "../../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  name: "ListaConstrucaoEtapas",
  components: {
    BaseList,
    CadastrarConstrucaoEtapas,
    EditarConstrucaoEtapa,
    CadastrarConstrucaoMaterial,
  },
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      construcaoEtapaSelect: null,
      construcaoEtapaKeySelect: null,
      construcaoEtapaDescricao: null,
      isStaff: localStorage.getItem('admin_isStaff'),
      construcaoId: this.$route.query.construcaoId,
      construcaoDescricao: this.$route.query.construcaoDescricao,
      columns: [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'etapa_exibicao', header: 'ETAPA',},
        {field: 'construcao_exibicao', header: 'CONSTRUÇÃO',},
        {field: 'data_inicio', header: 'DATA INÍCIO', align: 'text-center',},
        {field: 'data_termino_previsao', header: 'DATA PREVISÃO DE TÉRMINO', align: 'text-center',},
        {field: 'data_termino', header: 'DATA TÉRMINO', align: 'text-center',},
        {field: 'observacao', header: 'OBSERVAÇÃO', align: 'text-right',},
        {field: 'orcamento_etapa', header: 'ORÇAMENTO ETAPA(R$)', align: 'text-right',},
      ]
    };
  },
  methods: {
    atualizarListaDados(novoDado) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizaDados(dadoAtualizado) {
      const index = this.dados.results.findIndex(dado => dado.id === dadoAtualizado.id);
      if (index !== -1) {
        this.dados.results[index] = dadoAtualizado;
      }
    },
    abrirModal(tipo, id = null, key = null, construcaoEtapa = null) {
      this.modalAtivo = tipo;
      if (key) {
        this.construcaoEtapaKeySelect = key;
      }
      if (id) {
        this.construcaoEtapaSelect = id;
      }
      if (construcaoEtapa) {
        this.construcaoEtapaDescricao = construcaoEtapa
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    deletarItem(itemkey, itemId, itemNome) {
      let url = apiUrl.construcoes.etapaRetrieveUpdateDestroy(itemkey);
      alertDelete(itemkey, url, 'Você deseja deletar o registro?', `ID: ${itemId} | ${itemNome}`, () => {
        this.loadDataLazy(this.pagination);
      });
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.construcoes.etapaCreateList(this.construcaoId), params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados();
  },
};
</script>
